/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function createData(name, calories, fat, carbs, protein, price) {
  return {
    name,
    history: [
      {
        date: "2020-01-05",
        customerId: "110917001",
        amount: 3,
        size: "Frozen yoghurt",
        test: "110917001",
        test2: "1109170011",
        test3: "1109170012",
      },
      {
        date: "2020-01-02",
        customerId: "Anonymous1",
        amount: 1,
        size: "Ice cream sandwich",
      },
      {
        date: "2020-01-05",
        customerId: "110917002",
        amount: 3,
        size: "Ice cream sandwich",
      },
      {
        date: "2020-01-02",
        customerId: "Anonymous3",
        amount: 1,
        size: "Eclair",
      },
      {
        date: "2020-01-05",
        customerId: "110917003",
        amount: 3,
        size: "Eclair",
      },
      {
        date: "2020-01-02",
        customerId: "Anonymous3",
        amount: 1,
        size: "Frozen yoghurt5",
      },
      {
        date: "2020-01-05",
        customerId: "110917004",
        amount: 3,
        size: "Frozen yoghurt6",
      },
      {
        date: "2020-01-02",
        customerId: "Anonymous4",
        amount: 1,
        size: "Frozen yoghurt6",
      },
    ],
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow
        className={classes.root}
        style={{ backgroundColor: "rgb(186 195 243)", textAlign: "left" }}
      >
        <TableCell
          style={{
            backgroundColor: "rgb(250 189 119)",
            color: "white",
            width: 50,
          }}
        >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            style={{ color: "white" }}
          >
            {open ? (
              <KeyboardArrowUpIcon style={{ fontSize: 28 }} />
            ) : (
              <KeyboardArrowDownIcon style={{ fontSize: 28 }} />
            )}
          </IconButton>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          style={{
            fontSize: 20,
            color: "white",
            backgroundColor: "#3f51b5",
            textAlign: "left",
          }}
        >
          {row.name}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {row.rows.map((historyRow) =>
                      row.name == historyRow.rowMapTo ? (
                        <>
                          {row.name == "Color" ? (
                            <TableCell
                              style={{
                                fontWeight: "bold",
                                background: historyRow.columnRow,
                              }}
                            >
                              {historyRow.columnRow}
                            </TableCell>
                          ) : (
                            <TableCell style={{ fontWeight: "bold" }}>
                              {historyRow.columnRow}
                            </TableCell>
                          )}
                        </>
                      ) : (
                        ""
                      )
                    )}
                    {/* <TableCell>Date</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell align="right">Amount</TableCell>
                    <TableCell align="right">Total price ($)</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.rows.map((historyRow) =>
                    row.name == historyRow.rowMapTo ? (
                      <>
                        <TableCell>{historyRow.columnRowTotalOrders}</TableCell>
                      </>
                    ) : (
                      ""
                    )
                  )}
                  {/* {row.rows.map((historyRow) => (
                    <TableRow key={historyRow.date}>
                      {historyRow.columnRow == row.columnRow ? (
                        <>
                          <TableCell component="th" scope="row">
                            {historyRow.columnRow}
                          </TableCell>
                          <TableCell>{historyRow.customerId}</TableCell>
                          <TableCell align="right">
                            {historyRow.amount}
                          </TableCell>
                          <TableCell align="right">
                            {Math.round(historyRow.amount * row.price * 100) /
                              100}
                          </TableCell>
                        {row.name=="Frozen yoghurt" && (
                            <>
                        <TableCell align="right">
                        {historyRow.test}
                          </TableCell>
                          <TableCell align="right">
                          {historyRow.test2}
                          </TableCell>
                          <TableCell align="right">
                            {historyRow.test3}
                          </TableCell>
                          </>)
                          }


                        </>
                      ) : (
                        <></>
                      )}
                    </TableRow>
                  ))} */}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0, 3.99),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3, 4.99),
  createData("Eclair", 262, 16.0, 24, 6.0, 3.79),
  createData("Cupcake", 305, 3.7, 67, 4.3, 2.5),
  createData("Gingerbread", 356, 16.0, 49, 3.9, 1.5),
];

export default function CustomGroupWiseTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableBody>
          {props.rows.map((row) => (
            <Row key={row.name} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
